<template>
    <div>
        <b-tabs v-if="questions.length > 1" pills content-class="mt-3">
            <b-tab v-for="(question, index) in questions" :key="index" :title="buildTitle(question)">
                <div class="new-form">
                    <b-form @submit.prevent="onClickAddToCart($event, index)">

                        <form-event-block
                            :organization="organization"
                            :question="question"
                            :hide-header="hideHeader"
                            :hideRegButton="hideRegButton"
                            :proposeNames="true"
                            ref="eventBlock"
                        ></form-event-block>

                        <b-button variant="branded" type="submit">
                            <i class="fa fa-fw fa-plus"></i>
                            {{ trans('add_to_cart') }}
                        </b-button>

                    </b-form>
                </div>
            </b-tab>
            </b-tabs>
            <div v-if="questions.length == 1" class="new-form">
                <b-form @submit.prevent="onClickAddToCart($event, null)">
                    <form-event-block
                        :organization="organization"
                        :question="questions[0]"
                        :hide-header="hideHeader"
                        :hideRegButton="hideRegButton"
                        :proposeNames="true"
                        ref="eventBlock"
                    ></form-event-block>

                    <b-button variant="branded" type="submit">
                        <i class="fa fa-fw fa-plus"></i>
                        {{ trans('add_to_cart') }}
                    </b-button>
                </b-form>
            </div>
    </div>
</template>

<script>
  import FormEventBlock from './../form-questions/FormEventBlock'

  export default {
    props: {
      organization: Object,
      amClass: Object,
      hideHeader: {
        type: Boolean,
        default: false,
      },
      hideRegButton: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      FormEventBlock,
    },
    data() {
      return {
        trans: trans,
      }
    },
    computed: {
      questions() {
        return _.map(this.amClass.microsite_registration_questions, question => {
          return _.assign({}, question, {
            am_event: this.amClass
          })
        })
      },
    },
    methods: {
      buildTitle(question) {
        let title = question.label
        let price = _.classPrice(this.amClass, question)
        if (_.isNumeric(price)) title += ' ' + _.currency(price)
        return title
      },
      getDataFromRef(ref, question) {
        let data = {}

        if (ref.answers.event_block) {
          data.participant = ref.answers.event_block
        }

        if (ref.selected && ref.selected.length > 0) {
          let selected = ref.selected.map(Number);
          data.dates = _.filter(question.am_event.events || [], item => {
            return selected.includes(item.id)
          }).map((item) => {
            return moment(item.start).toISOString()
          })
        }

        if (ref.chosen) {
          let event = question.am_event.events.find(x => x.id == ref.chosen)
          data.dates = [moment(event.start).toISOString()]
        }

        return data
      },
      onClickAddToCart(e, index) {
        e.preventDefault()
        // tired of listeners
        // only works for one answer... WIP
        // should validate the form
        /*if (Array.isArray(this.$refs.eventBlock)) {
            var index = 0
            this.$refs.eventBlock.map((ref) => {
              window.onClassAddToCart(this.questions[index], this.getDataFromRef(ref, this.questions[index]))
              index++
            })
        } else {*/
            let question = index != null ? this.questions[index] : this.questions[0]
            let eventBlock = index != null ? this.$refs.eventBlock[index] : this.$refs.eventBlock

            console.log(index, question, eventBlock)

            window.onClassAddToCart(question, this.getDataFromRef(eventBlock, question))
        //}
      },
    },
    mounted() {
      window.classRegister = this
    },
  }
</script>
